import { Component } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { DateService } from '../../shared/services/date.service';
import { AuthService } from '../../shared/services/auth.service';

interface CurrencySummary {
  currency: string;
  country: string;
  count: number;
  amount: number;
}


@Component({
  selector: 'app-settlement',
  templateUrl: './settlement.component.html',
  standalone: false,
  styleUrls: ['./settlement.component.scss']
})
export class SettlementComponent {

  fromDate: string = '';
  toDate: string = '';

  totalCount: number = 0;
  totalAmount: number = 0;
  partnerCurrency: string = '';
  currencySummary: CurrencySummary[] = [];

  loaded: boolean = false;
  error: string = '';

  private isIssuer: boolean = false;

  constructor(
    private _api: ApiService,
    private _dateService: DateService,
    private _auth: AuthService
  ) {}

  onSubmit() {
    const vm = this;
    vm.error = '';
    vm.loaded = false;

    if (!vm.fromDate || !vm.toDate) {
      vm.error = 'Please select both start and end dates.';
      return;
    }

    const fromTimestamp = new Date(vm.fromDate).getTime();
    const toTimestamp = new Date(vm.toDate).getTime() + 86399999;

    if (fromTimestamp > toTimestamp) {
      vm.error = 'Start date must be before end date.';
      return;
    }

    const user = vm._auth.getUser();
    vm.isIssuer = user?.partnerId?.type === 'Issuer';

    const url = `/partners/auth/transactions/all?_page=1&_limit=500&createdAtdatePickerRange=${fromTimestamp},${toTimestamp}`;

    vm._api.getData(url).subscribe({
      next: (res: any) => {
        if (res && !res.error) {
          const transactions: any[] = res.data || [];
          vm.totalCount = res.count || transactions.length;

          const currencyMap: { [key: string]: { currency: string; country: string; count: number; amount: number } } = {};
          let localTotal = 0;

          transactions.forEach((t: any) => {
            try {
              const conv = JSON.parse(t.conversions);

              let localCurrency: string;
              let localAmount: number;
              let srcCurrency: string;
              let srcAmount: number;
              let country: string;

              if (vm.isIssuer) {
                localCurrency = conv.customerPays?.currency || conv.sourceCurrency || '';
                localAmount = parseFloat(conv.customerPays?.amount) || parseFloat(conv.sourceAmount) || 0;
                srcCurrency = localCurrency;
                srcAmount = localAmount;
                country = t.originationCountry?.displayName || t.originationCountry?.country_code || 'Unknown';
              } else {
                localCurrency = conv.recipientGets?.currency || '';
                localAmount = parseFloat(conv.recipientGets?.amount) || 0;
                srcCurrency = conv.customerPays?.currency || conv.sourceCurrency || '';
                srcAmount = parseFloat(conv.customerPays?.amount) || parseFloat(conv.sourceAmount) || 0;
                country = t.recipientCountry?.displayName || t.recipientCountry?.country_code || 'Unknown';
              }

              if (!vm.partnerCurrency && localCurrency) {
                vm.partnerCurrency = localCurrency;
              }

              if (localAmount > 0) {
                localTotal += localAmount;
              }

              if (srcCurrency) {
                const key = `${srcCurrency}__${country}`;
                if (!currencyMap[key]) {
                  currencyMap[key] = { currency: srcCurrency, country, count: 0, amount: 0 };
                }
                currencyMap[key].count++;
                currencyMap[key].amount += srcAmount;
              }
            } catch (e) {}
          });

          vm.totalAmount = localTotal;
          vm.currencySummary = Object.values(currencyMap);

          vm.loaded = true;
        } else {
          vm.error = 'Failed to load settlement data.';
        }
      },
      error: () => {
        vm.error = 'An error occurred while fetching data.';
      }
    });
  }
}
